// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const RoutesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  position: relative;
  z-index: 1;
`
